<div  class="border border-gray-300 rounded-md max-h-full">
    <div class="flex flex-row border-b border-gray-300 ">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        Nombre
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm">
        {{coleccionista.coleccionista.nombre}}
        </div>
    </div>

    <div class="flex flex-row border-b border-gray-300 ">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        Correo
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm">
        {{coleccionista.coleccionista.correoElectronico}}
        </div>
    </div>

    <div class="flex flex-row border-b border-gray-300 ">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        Teléfono
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm">
        {{coleccionista.coleccionista.telefono}}
        </div>
    </div>

    <div class="flex flex-row border-b border-gray-300 ">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        Departamento
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm">
        {{coleccionista.coleccionista.departamento.descripcion}}
        </div>
    </div>

    <div class="flex flex-row border-b border-gray-300 ">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        Municipio
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm">
        {{coleccionista.coleccionista.municipio.descripcion}}
        </div>
    </div>

    <div class="flex flex-row border-b border-gray-300 ">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        CUI
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm">
        {{coleccionista.coleccionista.cui}}
        </div>
    </div>

    <div class="flex flex-row">
        <div class="w-4/12 md:w-3/12 flex items-center pl-2 md:pl-4 font-semibold text-xs md:text-sm">
        Sección
        </div>
        <div class="flex-1 flex items-center text-secondary pl-0 md:pl-4 text-xs md:text-sm py-1">
            <status-sticker
                            [estado]="coleccionista.coleccionista.seccion.descripcion" 
                            [color1]="coleccionista.coleccionista.seccion?.valor1" 
                            [color2]="coleccionista.coleccionista.seccion?.valor2">
            </status-sticker>   
        </div>
    </div>
</div>